/*
 * Language toggle — a small floating chip beside the theme toggle,
 * bottom-left. A plain link to the other language's page: no JS state,
 * works everywhere, and crawlers see a real href between the two
 * language versions.
 *
 * The chip shows the TARGET language ("DA" on the English page, "EN" on
 * the Danish one), mirroring the theme toggle's convention of always
 * naming the destination.
 */

import type { LangToggleContent } from "../i18n/types";

export function renderLangToggle(t: LangToggleContent, href: string): HTMLElement {
  const link = document.createElement("a");
  link.className = "langtoggle";
  link.href = href;
  link.setAttribute("aria-label", `${t.ariaLabel}: ${t.targetName}`);
  link.setAttribute("hreflang", href === "/" ? "en" : "da");
  link.textContent = t.targetLabel;
  return link;
}
